import { useGetAccountId } from "@/lib/useGetAccountId"
import { computed, ref } from "vue"

const isSwitchAccountOpen = ref(false)

export function useSwitchAccount() {
  const accountIdQuery = useGetAccountId()

  const accountIDs = computed(() => accountIdQuery.data.value?.accountIDs || [])
  const currentAccountID = computed(
    () => accountIdQuery.data.value?.accountIDLastVisited,
  )
  const hasMultipleAccounts = computed(() => accountIDs.value.length > 1)

  const openSwitchAccount = () => {
    isSwitchAccountOpen.value = true
  }

  const closeSwitchAccount = () => {
    isSwitchAccountOpen.value = false
  }

  return {
    accountIDs,
    currentAccountID,
    isSwitchAccountOpen,
    hasMultipleAccounts,
    openSwitchAccount,
    closeSwitchAccount,
  }
}
